/**
 * @tabler/icons-react v2.25.0 - MIT
 */
import createReactComponent from '../createReactComponent.js';
var IconH5 = createReactComponent("h-5", "IconH5", [["path", {
  d: "M17 18h2a2 2 0 1 0 0 -4h-2v-4h4",
  key: "svg-0"
}], ["path", {
  d: "M4 6v12",
  key: "svg-1"
}], ["path", {
  d: "M12 6v12",
  key: "svg-2"
}], ["path", {
  d: "M11 18h2",
  key: "svg-3"
}], ["path", {
  d: "M3 18h2",
  key: "svg-4"
}], ["path", {
  d: "M4 12h8",
  key: "svg-5"
}], ["path", {
  d: "M3 6h2",
  key: "svg-6"
}], ["path", {
  d: "M11 6h2",
  key: "svg-7"
}]]);
export { IconH5 as default };